import UtilsSchema from "@repoflow/schema/utils";

import {
  orgId,
  workflowId,
  captureId,
  values,
  status,
  version,
  definitionUpdatedAt,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/Capture",
    type: "object",
    properties: {
      orgId,
      workflowId,
      captureId,
      values,
      status,
      version,
      definitionUpdatedAt,
      createdAt,
      updatedAt,
    },
  },
  {
    // What an anonymous visitor posts: the values and nothing else. Which
    // workflow they belong to comes from the share link, never from the input.
    id: "/Public/Capture/Create",
    type: "object",
    properties: {
      values,
    },
    // Mirrors CaptureInputCreate's non-null field exactly.
    required: ["values"],
  },
];
